export default "__VITE_ASSET__CK2Mv6iB__"